import {tagApi} from "@core/api";
import {Circle} from "@mui/icons-material";
import {
  Chip,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

const Tag = ({
  tag,
  container,
}: {
  tag: string;
  container?: "chip" | "listitem" | "div";
}) => {
  const {data: tags} = tagApi.useFindAllEntity(undefined);
  const theme = useTheme();

  if (!tags) return null;

  const tagData = tags.find(t => t.key === tag);
  if (!tagData) return null;

  if (container === "chip") {
    return (
      <Chip
        size="small"
        label={tagData.label}
        sx={{
          bgcolor: tagData.color,
          color: theme.palette.getContrastText(tagData.color),
        }}
      />
    );
  }

  if (container === "listitem") {
    return (
      <>
        <ListItemIcon>
          <Circle htmlColor={tagData.color} fontSize="inherit" />
        </ListItemIcon>
        <ListItemText primary={tagData.label} />
      </>
    );
  }

  if (container === "div") {
    return (
      <Stack direction={"row"} gap={1} alignItems={"center"}>
        <Circle htmlColor={tagData.color} fontSize="inherit" />
        <Typography>{tagData.label}</Typography>
      </Stack>
    );
  }

  return <>{tagData.label}</>;
};

export {Tag};
